<script>
import { mapGetters } from 'vuex'

import Layout from '@layouts/main.vue'
import CalculatorSection from '@components/common/calculator-section.vue'
import ListBullet from '@assets/icons/list-bullet.svg'
import ListTick from '@assets/icons/list-tick.svg'
import Slider from '@components/common/sliders/attractions-slider.vue'

import PassTypeSection from '@components/e-shop/pass-type-section.vue'
import ReviewOrderSection from '@components/e-shop/review-order-section.vue'
import EshopSuccess from '@components/e-shop/eshop-success.vue'

import Translatable from '@src/mixins/translatable.js'
import SanitizerMixin from '@src/mixins/sanitizer-mixin.js'
import ImageMixin from '@src/mixins/imageMixin.js'
import Resizable from '@src/mixins/resizable.js'
import AuthorLabel from '@src/mixins/author.js'

export default {
  page: {
    title: 'Buy / Prices ',
    meta: [{ name: 'description', content: 'Buy the original Prague Card/CoolPass - used by over 1 million' }],
  },
  components: {
    Layout,
    CalculatorSection,
    PassTypeSection,
    ReviewOrderSection,
    EshopSuccess,
  },
  mixins: [
    Translatable,
    SanitizerMixin,
    ImageMixin,
    Resizable,
    Slider,
    AuthorLabel,
  ],
  computed: {
    ...mapGetters('eShop', [
      'pageData',
      'userCards',
      'isFieldsValid',
      'userData',
    ]),
    ...mapGetters('getYourPass', ['prices']),
    isFieldsNonEmpty() {
      const userData = this.userData
      const isAllNonEmpty = userData.name && userData.email && userData.country

      return this.isFieldsValid
        ? this.isFieldsValid
        : isAllNonEmpty && !this.isFieldsValid
    },
    getListStyleBullet() {
      return {
        listStyleImage: `url(${ListBullet})`,
      }
    },
    getListStyleTick() {
      return {
        listStyleImage: `url(${ListTick})`,
      }
    },
    pageImg() {
      if (this.pageData.mainImage) {
        return this.desktopScreen
          ? this.pageData.mainImage.web_image
          : this.pageData.mainImage.app_image
      }
      return ''
    },
    sessionId() {
      return this.$route.query.session_id || this.$route.query.voucher_number
    },

  },

  beforeCreate() {
    const sessionId = {
      type: 'session',
      value: this.$route.query.session_id,
    }
    const voucherNumber = {
      type: 'voucher',
      value: this.$route.query.voucher_number,
    }

    const queryArray = [sessionId, voucherNumber]
    const queryValue = queryArray.find((data) => data.value)

    if (queryValue) {
      this.$store.dispatch('eShop/fetchOrder', queryValue)
    }
  },
  methods: {
    pageContent(prop) {
      if (this.prices.content) {
        return this.prices.content[this.currentLanguage][prop]
          ? this.prices.content[this.currentLanguage][prop]
          : this.prices.content.en[prop]
      }
      return ''
    },
     queryLang() {
      if(this.$route.query.lang){
          this.$store.commit('translations/SET_LANGUAGE', this.$route.query.lang)
          // this.$router.replace({'lang': null});
      }
      // else{
      //   var userLang = navigator.language || navigator.userLanguage;
      //   this.$store.commit('translations/SET_LANGUAGE', userLang.substring(0,2))
      // }
      if( this.$route.query.eshopId ){
        localStorage.setItem('eshopId', this.$route.query.eshopId)

      }
    },
  },
}
</script>

<template>
  <Layout v-bind="queryLang()">
    <section
      v-if="this.$route.query.mode !== 'iframe'"
      class="header-section justify-center"
      :style="getBackground(pageImg)"
    ></section>
    <section :style="this.$route.query.mode !== 'iframe' ? {} : { marginTop: '0' + 'px' }" class="description-banner-section justify-center">
      <div class="description-container">
        <p class="authorf container" v-html="authorLabel(pageData)"></p>
        <div class="description-header-container">
          <h1
            class="description-title"
            v-html="getTranslatedContent('title', pageData.content)"
          ></h1>
          <h3
            class="description-subtitle"
            v-html="getTranslatedContent('subtitle', pageData.content)"
          ></h3>
        </div>
        <div class="content-container">
          <section v-if="sessionId">
            <EshopSuccess />
          </section>
          <section v-else>
            <section id="prices" class="calculator-section justify-center">
              <p class="author container" v-html="authorLabel(pageData)"></p>
              <div class="container">
                <div class="section-title first">
                  <p>01</p>
                  <h3
                    v-html="getTranslatedContent('ESHOP_select_the_num_title')"
                  >
                  </h3>
                </div>
                <h3
                  class="calculator-section-subtitle"
                  v-html="pageContent('prices_description')"
                >
                </h3>
                <CalculatorSection :is-eshop="true" />
                <div class="tips">
                  <div class="first-tip-block">
                    <ul :style="getListStyleBullet" class="bullet-list">
                      <li>{{
                        getTranslatedContent('CALCULATOR_card_validity')
                      }}</li>
                      <li>{{
                        getTranslatedContent(
                          'CALCULATOR_child_card_validity_tip',
                        )
                      }}</li>
                      <li>{{
                        getTranslatedContent('CALCULATOR_student_id_info')
                      }}</li>
                    </ul>
                  </div>
                  <div class="second-tip-block">
                    <ul :style="getListStyleBullet" class="bullet-list">
                      <li>
                        {{ getTranslatedContent('CALCULATOR_groups_info') }}
                      </li>
                    </ul>
                  </div>
                  <div class="third-tip-block">
                    <div>
                      <p>{{ getTranslatedContent('ADULT_AGE') }}</p>
                      <p>{{ getTranslatedContent('STUDENT_AGE') }}</p>
                      <p>{{ getTranslatedContent('CHILD_AGE') }}</p>
                    </div>
                    <router-link :to="`/cancellation-and-refund`" class="link">
                      <button class="button-cancel">{{
                        getTranslatedContent('CANCELLATION_POLICY')
                      }}</button>
                    </router-link>
                  </div>
                </div>
              </div>
            </section>
            <section
              v-show="userCards.length || isFieldsValid"
              class="pass-type-section justify-center"
            >
              <div class="container">
                <div class="section-title">
                  <p>02</p>
                  <h3
                    v-html="getTranslatedContent('ESHOP_select_the_type_title')"
                  >
                  </h3>
                </div>
                <PassTypeSection />
              </div>
            </section>
            <section
              v-show="userCards.length && isFieldsNonEmpty"
              class="review-order-section justify-center"
            >
              <div class="container">
                <div class="section-title">
                  <p>03</p>
                  <h3 v-html="getTranslatedContent('ESHOP_review_order_title')">
                  </h3>
                </div>
                <ReviewOrderSection />
              </div>
            </section>
          </section>
        </div>
      </div>
    </section>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
@import '@styles/author_text.scss';

.header-section {
  height: 550px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.description-banner-section {
  margin-top: -335px;

  & .description-container {
    width: 1170px;
    min-height: 800px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    border-radius: 20px;
    box-sizing: border-box;
    background: $white;
    box-shadow: 0 8px 12px rgba(76, 72, 124, 0.08);
    padding: 15px;
  }
}

.description-header-container {
  width: 100%;
  min-height: 120px;
  height: auto;
  background: $dark-blue;
  padding: 10px 0 20px;
  border-radius: 10px;

  .description-title {
    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    font-size: 48px;
    line-height: 62px;
    text-transform: uppercase;
    margin: 0 22px;
    color: $white;
  }

  .description-subtitle {
    font-family: Open Sans Semibold, sans-serif;
    font-weight: 600;
    font-size: 22px;
    line-height: 29px;
    margin: 0 25px;
    color: $white;
  }
}

.content-container {
  margin-top: 30px;
  width: 100%; //
}

.section-title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 22px;
  line-height: 29px;
  text-transform: uppercase;
  color: $dark-blue;
  margin-bottom: 15px;
  margin-top: 70px;
  display: flex;

  p {
    margin-right: 11px;
    font-size: 26px;
    line-height: 28px;
    color: $orange;
  }

  &.first {
    margin-top: 0px;
  }
}

::v-deep .calculator-section-subtitle {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: $black;

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }

  & ul {
    margin-left: 20px;
    list-style: initial;
  }

  & strong {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
  }
}

.link {
  display: block;
  outline: none;
  height: 48px;
}

.tips {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
  height: auto;
}

.tips ul {
  list-style: disc outside;
  width: 353px;
}

.tips ul li {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: $black;
  // opacity: 0.8;
  margin-bottom: 10px;
  padding-left: 10px;
}

.first-tip-block,
.second-tip-block,
.first-tip-detail-block,
.second-tip-detail-block {
  display: flex;
  justify-content: flex-end;
}

.third-tip-block {
  display: flex;
  justify-content: space-between;
}

.first-tip-block,
.third-tip-block {
  margin-top: 33px;
}

.second-tip-block {
  margin-top: 43px;
}

.third-tip-block p {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: $black;
  // opacity: 0.8;
  margin-bottom: 10px;
}

.third-tip-block p:last-child {
  margin-bottom: 0;
}

.button-cancel {
  min-width: 175px;
  max-width: 185px;
  min-height: 48px;
  border: 1px solid $gray;
  border-radius: 5px;
  background: $white;
  color: $gray;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  padding: 12px 20px;

  &:hover {
    border: none;
    background: $gray;
    color: $white;
  }
}

@media only screen and (max-width: $screen-width-xs) {
  .container {
    width: 100%;
  }

  .header-section {
    height: 244px;
  }

  .description-header-container {
    width: 100%;
    margin-top: 70px;
    margin-right: 0;
    min-height: 125px;
    height: auto;

    .description-title {
      font-family: Open Sans Bold, sans-serif;
      font-weight: bold;
      font-size: 26px;
      line-height: 34px;
      text-transform: uppercase;
      margin: 20px 8px 10px;
      color: $white;
      text-align: center;
    }

    .description-subtitle {
      font-family: Open Sans Semibold, sans-serif;
      font-weight: 600;
      font-size: 16px;
      line-height: 21px;
      color: $white;
      margin: 0 8px;
      text-align: center;
    }
  }

  .description-banner-section {
    margin: -130px 0 40px;
    & .description-container {
      width: 100%;
      padding: 0;
      padding-bottom: 15px;
    }
  }

  .description-header-container {
    margin-top: -20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content-container {
    width: 100%;
    margin-top: 20px;
  }

  .section-title {
    font-size: 18px;
    line-height: 23px;
    margin-top: 44px;

    p {
      margin-right: 11px;
      font-size: 22px;
      line-height: 29px;
    }

    &.first {
      margin-top: 14px;
    }
  }

  .calculator-section-subtitle {
    margin-bottom: 20px;
  }

  .tips {
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
    column-gap: 0px;
  }

  .tips {
    margin-top: 15px;
  }

  .tips ul {
    width: 100%;
  }

  .first-tip-block,
  .second-tip-block,
  .third-tip-block {
    margin: 0 0 0 15px;
    justify-content: flex-start;
  }

  .third-tip-block {
    margin-left: 25px;
    justify-content: space-between;

    p {
      font-family: Open Sans Semibold, sans-serif;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      color: $black;
      // opacity: 0.8;
      margin-bottom: 10px;
    }
  }

  .button-cancel {
    min-width: 142px;
    max-width: 162px;
    height: 35px;
    padding: 0;
  }

  .third-tip-detail-block {
    justify-content: space-between;

    .link {
      width: 100%;
    }
  }

  .first-tip-detail-block,
  .second-tip-detail-block {
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 15px;
  }

  .third-tip-detail-block ul li {
    margin-left: 15px;
  }

  .review-order-section {
    .container {
      padding: 0;
    }

    .section-title {
      margin-right: 8px;
      margin-left: 8px;
    }
  }
}
</style>
